import { useCallback, useRef, type ReactNode } from "react";
import type { ActionCardHostProps } from "./card-props";

function Widget({ render, onToken }: { render: NonNullable<ActionCardHostProps["renderCaptcha"]>; onToken: (token: string | null) => void }) {
  return <>{render(onToken)}</>;
}

export interface CaptchaSlot {
  /** The host's widget (remounted after every attempt), or null when the host has none. */
  node: ReactNode;
  /** The latest token, once: tokens are single use. Null until the widget produced a new one. */
  take: () => string | null;
}

/** Holds the bot-check token of a card between the widget (host) and the submit (card). */
export function useCaptcha(render: ActionCardHostProps["renderCaptcha"], attempts: number): CaptchaSlot {
  const latest = useRef<string | null>(null);
  const onToken = useCallback((value: string | null) => {
    latest.current = value;
  }, []);
  const take = useCallback(() => {
    const token = latest.current;
    latest.current = null;
    return token;
  }, []);
  return { node: render ? <Widget key={attempts} render={render} onToken={onToken} /> : null, take };
}
